import type { NskResponse } from "~/models/Api";
import type { ImportConversionParam } from "~/models/ImportConversion";
import type { ImportType } from "~/models/ImportLog";
import { deleteRequest, postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/admin/import_conversions",
	destroy: (id: number) => `/admin/import_conversions/${id}`
} as const;

export const create = async (
	importType: ImportType,
	importConversion: ImportConversionParam
): Promise<NskResponse> =>
	postRequest(paths.create, { importConversion, importType });

export const destroy = async (
	id: number,
	importType: ImportType
): Promise<NskResponse> => deleteRequest(paths.destroy(id), { importType });
